import Vue from 'vue';
import { Notifier } from '@airbrake/browser';
import { getEnvironment } from '../utils/environment.js';

const currentEnvironment = getEnvironment();

let airbrake = null;
if (currentEnvironment === 'staging' || currentEnvironment === 'production') {
  airbrake = new Notifier({
    projectId: 1,
    projectKey: '07e64b4f53e820d175104e6ca221e587',
    host: 'https://errbit.devops.archibase.co.jp',
    environment: currentEnvironment,
    remoteConfig: false
  });
}

function notifyAirbrake(error, context = {}) {
  if (!airbrake) return;
  
  airbrake.notify({
    error,
    context: {
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      environment: currentEnvironment,
      ...context
    }
  });
}

export function initializeAirbrake() {
  // グローバルエラーハンドラー
  window.addEventListener('error', (event) => {
    notifyAirbrake(event.error);
  });

  // Promise rejection エラーハンドラー
  window.addEventListener('unhandledrejection', (event) => {
    notifyAirbrake(event.reason, { type: 'unhandledrejection' });
  });

  // Vue.js エラーハンドラー
  Vue.config.errorHandler = (err, vm, info) => {
    notifyAirbrake(err, {
      vueInfo: info,
      componentName: vm?.$options?.name || 'Unknown'
    });
    throw err;
  };

  // windowにairbrakeを設定
  window.airbrake = airbrake;
}
